<div *cabSpinner="isLoading">
  @if (content && !hasError) {
    <div class="content" [innerHTML]="content | decodedSafeHtml"></div>
  } @else {
    <p>{{ 'errors.error_loading_content' | translate }}</p>
  }
</div>
